"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var panel = function (props) {
    var className = props.className, children = props.children, nomargin = props.nomargin, rest = __rest(props, ["className", "children", "nomargin"]);
    var cn = classnames_1.default("emankit__panel", {
        nomargin: nomargin,
    }, className);
    var title;
    if (props.title) {
        title = react_1.default.createElement("span", { className: "emankit__panel__title" }, props.title);
    }
    return (react_1.default.createElement("div", __assign({ className: cn }, rest),
        title,
        children));
};
exports.default = panel;
//# sourceMappingURL=index.js.map